import protoRoot from "../proto-root";
import environment from "src/utils/environment";

function create({ stationType }) {
  const SupportedFeaturesType = protoRoot.lookupEnum("comm.SupportedFeaturesType");
  const { values } = SupportedFeaturesType;
  const supportedFeatures = [
    values["WEBRTC_NATIVE_AV"],
    values["ONLINE_BACKGROUND_MODE"],
    values["STATION_SYNC"],
    values["VIDEO_RECORDING"],
    values["VIDEO_SNAPSHOT"],
    values["MOTION_DETECTION"],
    values["WEBRTC_PERFECT_NEGOTIATION"]
  ];

  if (environment.supportsCommands) {
    supportedFeatures.push(values["DOG_COMMANDS"]);
  }
  if (stationType === "parent" && environment.supportsLullabies) {
    supportedFeatures.push(values["LULLABIES"]);
  }

  return supportedFeatures;
}

export default {
  create
};
